<script>
import { mapGetters } from 'vuex'

import MonitorEdges from '@/assets/screen/MonitorEdges'

import notifications from '@/services/notifications'

import CrtOverlayTitle from './CrtOverlayTitle'

export default {
  name: 'CrtFrame',

  components: {
    CrtOverlayTitle,
    MonitorEdges
  },

  data () {
    return {
      isOn: false,
      hasBeenTurnedOff: false
    }
  },

  mounted () {
    setTimeout(() => {
      this.isOn = true
    }, 500)
  },

  computed: {

    ...mapGetters([
      'crtFlicker'
    ]),

    overlayTitle () {
      return notifications.overlayTitle
    }

  }

}
</script>

<template>
  <div
    :class="{
      'c-crt-frame-with-flicker': crtFlicker,
      'c-crt-frame-on': isOn,
      'c-crt-frame-off': !isOn,
      'c-crt-frame-turned-off': !isOn && hasBeenTurnedOff
    }"
    class="c-crt-frame"
  >
    <div class="c-crt-frame-inner">

      <monitor-edges
        class="c-crt-frame-monitor-edges"
        preserveAspectRatio="none"
      />

      <div class="c-crt-frame-scanline" />

      <div class="c-crt-frame-overlay">
        <div class="c-crt-frame-overlay-content">
          <crt-overlay-title
            v-if="overlayTitle"
            :message="overlayTitle"
          />
        </div>
      </div>

      <div class="c-crt-frame-content">
        <div class="c-crt-frame-content-inner">
          <slot />
        </div>
      </div>

    </div>
  </div>
</template>

<style lang="scss">

$c-crt-frame-screen-background: $default-background-color;
$c-crt-frame-overlay-color: $green;

.c-crt-frame {
  @include no-overflow;
  background: $c-crt-frame-screen-background;

  &::after,
  &::before {
    @include block;
    @include fixed;
    @include no-pointer-events;
    content: '';
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  // Scanlines
  &::before {
    z-index: 3;
    background-size: 100% 2px, 3px 100%;
    background:
      linear-gradient(
        transparent($c-crt-frame-screen-background) 50%,
        translucent(darken($c-crt-frame-screen-background, 10), 0.15) 50%
      ),
      linear-gradient(
        90deg,
        transparentize($red, 0.94),
        transparentize($green, 0.98),
        transparentize($blue, 0.94)
      );
  }

}

.c-crt-frame-overlay,
.c-crt-frame-content {
  @include fill;
}

.c-crt-frame-scanline {
  @include absolute;
  @include no-pointer-events;
  width: 100%;
  height: 100%;
}

.c-crt-frame-inner,
.c-crt-frame-overlay-content,
.c-crt-frame-content-inner {
  @include fill-relative;
}

// Turn on and off effect

.c-crt-frame-off {

  .c-crt-frame-content {
    transform: scale(0.000, 0.0001) translate3d(0, 0, 0);
    filter: brightness(50);
  }

}

.c-crt-frame-on {

  .c-crt-frame-content {
    animation-name: turn-on;
    animation-duration: 2s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
  }

}

.c-crt-frame-turned-off {

  .c-crt-frame-content {
    animation-name: turn-off;
    animation-duration: 0.55s;
    animation-timing-function: $ease-out-quint;
    animation-fill-mode: forwards;
  }

}

// Overlay

.c-crt-frame-overlay {
  @include fill;
  @include fixed;
  @include no-pointer-events;
  z-index: 20;
  color: $c-crt-frame-overlay-color;
}

// Big scanline

@keyframes c-crt-frame-scanline {

  0% {
    bottom: 100%;
  }

  80% {
    bottom: 100%;
  }

  100% {
    bottom: 0%;
  }

}

.c-crt-frame-scanline {
  bottom: 100%;
  z-index: 8;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(255, 255, 255, 0.2) 10%,
    rgba(0, 0, 0, 0.1) 100%
  );
  opacity: 0.1;
  animation: c-crt-frame-scanline 10s linear infinite;
}

// Monitor edges

.c-crt-frame-monitor-edges {
  @include fill;
  @include no-pointer-events;
  z-index: 40;
  box-shadow: inset 0 0 8rem 1rem translucent($black, 0.75);

  // FIXME: animate inset shadow

  path {
    width: 100%;
    height: 100%;
  }

}

// Effects enabled

@keyframes c-crt-frame-flicker {
  $steps: 20;

  @for $i from 0 through $steps{
    #{percentage($i * (1 / $steps))}{
      opacity: random();
    }
  }
}

.c-crt-frame-with-flicker {

  // Flicker
  &::after {
    z-index: 2;
    opacity: 0;
    background: translucent($c-crt-frame-screen-background, 0.15);
  }

  &.c-crt-frame-on {
    &::after {
      animation: c-crt-frame-flicker 0.15s infinite;
    }
  }

  // .c-crt-frame-overlay,
  .c-crt-frame-content-inner {
    animation-duration: 4s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }

  .c-crt-frame-content-inner {
    animation-name: screen-text-glow-red-blue;
  }

  .c-crt-frame-overlay {
    animation-name: screen-text-glow-green;
  }

}

</style>
